import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";

import {
  ADD_PLANS,
  ADD_PLANS_RESPONSE,
  DELETE_PLANS,
  DELETE_PLANS_RESPONSE,
  GET_PLANS_LIST,
  SET_PLANS_LIST,
  GET_PLANS_BY_ID,
  SET_PLANS_BY_ID,
  GET_PLAN_TEMPLATE_BY_ID,
  SET_PLAN_TEMPLATE_BY_ID,
  UPDATE_PLANS,
  UPDATE_PLANS_RESPONSE,
  GET_MODULES_AND_FEATURES_LIST,
  SET_MODULES_AND_FEATURES_LIST
} from "./actionTypes";

export class GetPlansList implements Action {
  readonly type = GET_PLANS_LIST;
}

export class SetPlansList implements Action {
  readonly type = SET_PLANS_LIST;
  readonly payload = [];
  constructor(plansList: Array<any>) {
    this.payload = plansList;
  }
}

export class GetModulesAndFeatures implements Action {
  readonly type = GET_MODULES_AND_FEATURES_LIST;
}

export class SetModulesAndFeatures implements Action {
  readonly type = SET_MODULES_AND_FEATURES_LIST;
  readonly payload = [];
  constructor(modulesAndFeatures: Array<any>) {
    this.payload = modulesAndFeatures;
  }
}

export class GetPlansById implements Action {
  readonly type = GET_PLANS_BY_ID;
  readonly payload: string = null;
  constructor(id) {
    this.payload = id;
  }
}

export class SetPlansById implements Action {
  readonly type = SET_PLANS_BY_ID;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class GetPlanTemplateById implements Action {
  readonly type = GET_PLAN_TEMPLATE_BY_ID;
  readonly payload: string = null;
  constructor(id) {
    this.payload = id;
  }
}

export class SetPlanTemplateById implements Action {
  readonly type = SET_PLAN_TEMPLATE_BY_ID;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class AddPlans implements Action {
  readonly type = ADD_PLANS;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class AddPlansResponse implements Action {
  readonly type = ADD_PLANS_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class UpdatePlans implements Action {
  readonly type = UPDATE_PLANS;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class UpdatePlansResponse implements Action {
  readonly type = UPDATE_PLANS_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class DeletePlans implements Action {
  readonly type = DELETE_PLANS;
  readonly payload = null;
  constructor(id: string) {
    this.payload = id;
  }
}

export class DeletePlansResponse implements Action {
  readonly type = DELETE_PLANS_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export type Actions =
  | GetPlansList
  | SetPlansList
  | GetModulesAndFeatures
  | SetModulesAndFeatures
  | GetPlansById
  | SetPlansById
  | GetPlanTemplateById
  | SetPlanTemplateById
  | AddPlans
  | AddPlansResponse
  | UpdatePlans
  | UpdatePlansResponse
  | DeletePlans
  | DeletePlansResponse;
